export const DEFAULT_REMARKETING_EMAIL_TEMPLATE =
  '<html><body><div><a href="{{{unsubscribeUrl}}}">Unsubscribe</a><a href="{{{emailTrackingUnsubscribeUrl}}}">Opt out of email tracking</a></div></body></html>';
export const DEFAULT_UNSUBSCRIBE_PAGE_TEMPLATE = '<html><body></body></html>';
/** Landing page default when creating email-tracking unsubscribe templates. */
export const DEFAULT_EMAIL_TRACKING_UNSUBSCRIBE_PAGE_TEMPLATE = '<html><body></body></html>';

/** Minimal valid RCS JSON template (Link Mobility RCS card format) */
export const DEFAULT_RCS_TEMPLATE = JSON.stringify(
  {
    messages: [
      {
        channelId: 'rcs',
        // Link Mobility RCS: userId is the recipient's mobile phone number
        userId: '{{phone.mobile}}',
        content: {
          card: {
            title: 'Welcome',
            text: 'Hello {{customer.firstName}}, this is your RCS message.',
          },
        },
      },
    ],
  },
  null,
  2,
);
